import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledArticleTextIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <rect fill='none' x='8.5' y='6.5' width='15' height='19' rx='1.10875' />
            <path
                stroke='none'
                d='M17.4538 15.58H14.5438L14.0438 17H12.8538L15.3438 10.04H16.6638L19.1538 17H17.9538L17.4538 15.58ZM17.1338 14.65L16.0038 11.42L14.8638 14.65H17.1338Z'
            />
            <path fill='none' d='M11.5132 18.6294L20.4872 18.6294' strokeLinecap='round' />
            <path fill='none' d='M11.5132 21.1848L20.4872 21.1848' strokeLinecap='round' />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    height: 32px;
    width: 32px;
    stroke: ${p => p.stroke || p.theme.bgColor};
    fill: ${p => p.fill || p.theme.bgColor};
`
